import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";

type BookingPoint = {
  x: number;
  y: number;
  actual_bookings: number;
  date: string;
  formatted_date: string;
};

type BookingChartProps = {
  data: BookingPoint[];
};

const BookingChart = ({ data }: BookingChartProps) => {
  const xData = data.map((item) => item.x);
  const yData = data.map((item) => item.y);

  return (
    <div className="card">
      <div className=" card-header dashboard-card-header">
        <h6 className="mb-0 fw-semibold">Booking Forecast</h6>
      </div>
      <div>
        <LineChart
          xAxis={[
            {
              data: xData,
              valueFormatter: (value: number) => {
                const point = data.find((d) => d.x === value);
                return point ? point?.formatted_date : "";
              },
            },
          ]}
          series={[
            {
              data: yData,
              color: "#d5ad27",
              valueFormatter: (_: number | null, context) => {
                const index = context.dataIndex;
                const point = data[index];
                return `${point?.actual_bookings} bookings (${point?.formatted_date})`;
              },
            },
          ]}
          height={337}
          width={undefined}
          // slotProps={{
          //   tooltip: { trigger: "axis" },
          // }}
        />
      </div>
    </div>
  );
};

export default BookingChart;
